import '@babel/polyfill';
import { createRoot } from 'react-dom/client';
import App from './component/app';

/** Date-picker */
import 'react-dates/lib/css/_datepicker.css';
import 'rc-tooltip/assets/bootstrap.css';

/** Material styles */
import '@material/layout-grid/dist/mdc.layout-grid.min.css';
import '@material/button/dist/mdc.button.min.css';
import '@material/form-field/dist/mdc.form-field.min.css';
import '@material/checkbox/dist/mdc.checkbox.min.css';
import '@material/switch/dist/mdc.switch.min.css';
import '@material/textfield/dist/mdc.textfield.min.css';
import '@material/menu-surface/dist/mdc.menu-surface.min.css';
import '@material/dialog/dist/mdc.dialog.min.css';
import '@material/snackbar/dist/mdc.snackbar.min.css';
import '@material/typography/dist/mdc.typography.min.css';

/** RMWC styles */
import '@rmwc/avatar/avatar.css';
import '@rmwc/icon/icon.css';
import '@rmwc/circular-progress/circular-progress.css';

/** font awesome styles */
import '@fortawesome/fontawesome-pro/css/solid.min.css';
import '@fortawesome/fontawesome-pro/css/regular.min.css';
import '@fortawesome/fontawesome-pro/css/light.min.css';
import '@fortawesome/fontawesome-pro/css/fontawesome.min.css';

const container = document.getElementById('application');
const root = createRoot(container);
root.render(<App />);
